import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { IconButton, Menu, MenuItem } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { isFunction } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';

import { Dialog } from '..';

import { Container } from './style';

export default function Mobile({
  header,
  labels,
  content,
  edit,
  unique,
  remove,
  edition,
  onCallback,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();

  async function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  async function handeEditItem() {
    await setAnchorEl(null);
    await edit();
  }

  async function removeItem() {
    const url = [];

    unique.map((un) => {
      url.push(content[un]);

      return true;
    });

    await setAnchorEl(null);
    await dispatch(remove(url.join('/')));
  }

  return (
    <Container onClick={() => onCallback(content)}>
      <header>
        <h2>{header}</h2>
        {(isFunction(remove) || edition) && (
          <IconButton
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MoreVert />
          </IconButton>
        )}
      </header>

      {labels.map((mobile) => (
        <div key={mobile.id}>
          <strong>{mobile.label}</strong>
          <p>{content[mobile.id]}</p>
        </div>
      ))}

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {edition && (
          <MenuItem onClick={() => handeEditItem()}>
            {t('s.geral.botaoalterar')}
          </MenuItem>
        )}

        {isFunction(remove) && (
          <Dialog
            callback={() => removeItem()}
            text={t('s.geral.botaoexcluir')}
          />
        )}
      </Menu>
    </Container>
  );
}

Mobile.propTypes = {
  header: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(PropTypes.any).isRequired,
  content: PropTypes.objectOf(PropTypes.any).isRequired,
  unique: PropTypes.arrayOf(PropTypes.string).isRequired,
  remove: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]).isRequired,
  edit: PropTypes.func.isRequired,
  edition: PropTypes.bool.isRequired,
  onCallback: PropTypes.func.isRequired,
};
